!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {
$(document).ready(function() {
  setTimeout(function () {
    $(window).trigger('resize');
          $('.ts-sw-select').on('change', function(){
           setTimeout(function () {
            $(this).trigger('resize');
             }, 2000)
    //alert("est");
    });
     }, 4000);
});
});
}(jQuery);